// extracted by mini-css-extract-plugin
export default {"ClientChart":"ClientChart_ClientChart__S5ZjS"};